module.exports = __webpack_public_path__ + "static/media/093-basque-country.b8959fe1.svg";